import React from 'react'
import Header from './header'
import Footer from './footer'
import "../App.css"

export default function Projects() {
  return (
    <div>
      <Header />
      <div className='Certificates '>
        <h1 className='certificat d-flex justify-content-center '>Certificates</h1>
        <div class=" Certificate d-flex justify-content-center ">

          <div class="card me-4 " style={{ width: "18rem", height: "18rem" }}>
            <div class="card-body ">
              <h5 class="card-title mt-1 " >Microsoft Project ile Proje Yönetimi</h5>
              <h6 class="card-subtitle mt-2 text-muted" style={{ fontWeight: "bold" }}>BTK Akademi</h6>
              <p class="card-text mt-2">Microsoft Project Uygulaması detaylı olarak anlatıldığı bir eğitim.</p>
              <a href="https://drive.google.com/drive/folders/1JOeh_UGj8_hfuguLOy_YTzcwwuuokLwy" className="card-link mt-1" >certificate Link</a>

            </div>
          </div>
          <div class="card me-4 " style={{ width: "18rem", height: "18rem" }}>
            <div class="card-body ">
              <h5 class="card-title mt-1 " >Uluslararası İş Analizi Metodolojisi ve Teknikleri</h5>
              <h6 class="card-subtitle mt-2 text-muted" style={{ fontWeight: "bold" }}>BTK Akademi</h6>
              <p class="card-text mt-2">Analiz dokümanı, Gereksinim analizleri vs. konularının detaylı olarak anlatıldığı bir eğitim.</p>
              <a href="https://drive.google.com/file/d/1oeAtfPyrim5fkzTIZfEKYcM1RBBJEO4W/view?usp=sharing" className="card-link mt-1" >certificate Link</a>

            </div>
          </div>
          <div class="card me-4 " style={{ width: "18rem", height: "18rem" }}>
            <div class="card-body ">
              <h5 class="card-title mt-2 " style={{ textAlign: "center" }}>HTML / CSS</h5>
              <h6 class="card-subtitle mt-4 text-muted" style={{ fontWeight: "bold" }}>BTK Akademi</h6>
              <p class="card-text mt-4">CSS temelleri ile uygulama geliştirme</p>
              <a href="https://drive.google.com/file/d/1L_1I0R8ZX7FF7N_il9zl4XIE6HOmlDsF/view?usp=share_link" className="card-link mt-3" >certificate Link</a>

            </div>
          </div>
          <div class="card me-4 " style={{ width: "18rem", height: "18rem" }}>
            <div class="card-body ">
              <h5 class="card-title mt-2 " style={{ textAlign: "center" }}>Power BI Desktop for Technical Users</h5>
              <h6 class="card-subtitle mt-4 text-muted" style={{ fontWeight: "bold" }}>Bilginç IT Academy</h6>
              <p class="card-text mt-4">Power BI Desktop uygulamasının uçtan uca gösterimi </p>
              <a href="https://bilginc.com/certificates/BC000276447" className="card-link mt-3" >certificate Link</a>

            </div>
          </div>
          <div class="card me-4 " style={{ width: "18rem", height: "18rem" }}>
            <div class="card-body ">
              <h5 class="card-title mt-2 " style={{ textAlign: "center" }}>Power BI Service</h5>
              <h6 class="card-subtitle mt-4 text-muted" style={{ fontWeight: "bold" }}>Bilginç IT Academy</h6>
              <p class="card-text mt-4">Power BI Servislerinin kullanımı ve gösterimi</p>
              <a href="https://bilginc.com/certificates/BC000276486" className="card-link mt-3" >certificate Link</a>

            </div>
          </div>
          <div class="card me-4 " style={{ width: "18rem", height: "18rem" }}>
            <div class="card-body ">
              <h5 class="card-title mt-2 " style={{ textAlign: "center" }}>APPLE Teacher</h5>
              <h6 class="card-subtitle mt-4 text-muted" style={{ fontWeight: "bold" }}>Apple</h6>
              <p class="card-text mt-4">Apple tüm görev rozetlerini alarak lisanlı Apple Teacher olmaya hak kazandım.</p>
              <a href="https://drive.google.com/file/d/1sXoCLGVHuWXPklCUTHQBYRJcsTwY33Il/view?usp=sharing" className="card-link mt-3" >certificate Link</a>

            </div>
          </div>
          <div class="card me-4 " style={{ width: "18rem", height: "18rem" }}>
            <div class="card-body ">
              <h5 class="card-title " style={{ textAlign: "center" }}>Office 365 Teacher Academy</h5>
              <h6 class="card-subtitle mt-1 text-muted" style={{ fontWeight: "bold" }}>Microsoft</h6>
              <p class="card-text">Word,Excel,Powerpoint,Teams,Onenote vs. uygulamalarının eğitimini tamamladım. Sonrasında sınava girerek sertifika almaya hak kazandım.</p>
              <a href="https://drive.google.com/file/d/1Q0ts9W5xPXaYfR5fOhbtnUypuHZClk11/view?usp=sharing" className="card-link mt-3" >certificate Link</a>

            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}
